import { bigIntDividePresision } from '../consts';
import { customToFixed, customToFixedPretty } from './custom-to-fixed';

const dataUnits = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

export const DataUnitsTransform = (value: number, decimals = 0, pretty = false, relativeTo?: number): string => {
  const type = DataUnitsgetUnitType(Math.max(Number(value), Number(relativeTo || 0n)), pretty);
  const newVal = DataUnitsCalc(value, type);
  if (pretty) return customToFixedPretty(newVal, 3) + (relativeTo ? '' : ' ' + type);
  return customToFixed(newVal, decimals) + (relativeTo ? '' : ' ' + type);
};

export const DataUnitsTransformBigInt = (value: bigint, decimals = 0, pretty = false, relativeTo?: bigint): string => {
  const type = DataUnitsgetUnitTypeBigInt(Math.max(Number(value), Number(relativeTo || 0n)), pretty);
  const newVal = DataUnitsCalcBigInt(value, type);
  if (pretty) return customToFixedPretty(newVal, 3) + (relativeTo ? '' : ' ' + type);
  return customToFixed(newVal, decimals) + (relativeTo ? '' : ' ' + type);
};

export const calcAssetSizeGroup = (size: bigint) => {
  if (size < 1024n ** 2n) return '< 1MB';
  return DataUnitsTransformBigInt(size);
};

const DataUnitsCalc = (value: number, type: string, base = 0): number => {
  const unitIndex = dataUnits.indexOf(type);
  for (let i = base; i < unitIndex; i++) value /= getMultiplicationValue(i);
  return value;
};

const DataUnitsCalcBigInt = (value: bigint, type: string, base = 0): number => {
  value *= bigIntDividePresision;
  const unitIndex = dataUnits.indexOf(type);
  for (let i = base; i < unitIndex; i++) value /= getMultiplicationValueBigInt(i);
  return Number(value) / Number(bigIntDividePresision);
};

const DataUnitsgetUnitType = (value: number, pretty = false) => {
  if (value === 0) return dataUnits[2];
  if (value < 0) value = value * -1;
  let unitIndex = 0;
  while (value >= getMultiplicationValue(unitIndex)) {
    unitIndex += 1;
    value /= getMultiplicationValue(unitIndex);
  }
  if (pretty && !value) return dataUnits[Math.max(unitIndex, 2)];
  return dataUnits[unitIndex];
};

const DataUnitsgetUnitTypeBigInt = (value: number | bigint, pretty = false) => {
  if (value === 0) return dataUnits[2];
  if (typeof value !== 'bigint') value = BigInt(value);
  if (value < 0) value = value * -1n;
  let unitIndex = 0;
  while (value >= getMultiplicationValue(unitIndex)) {
    unitIndex += 1;
    value /= getMultiplicationValueBigInt(unitIndex);
  }
  if (pretty && !value) return dataUnits[Math.max(unitIndex, 2)];
  return dataUnits[unitIndex];
};

const getMultiplicationValue = (unitIndex: number) => {
  return dataUnits[unitIndex] === 'GB' ? 1000 : 1024;
};

const getMultiplicationValueBigInt = (unitIndex: number) => {
  return BigInt(getMultiplicationValue(unitIndex));
};
